import React, { createContext, useContext, useState, useEffect } from 'react';

const PaymentPlatformContext = createContext();

export const usePaymentPlatform = () => {
  const context = useContext(PaymentPlatformContext);
  if (!context) {
    throw new Error('usePaymentPlatform must be used within a PaymentPlatformProvider');
  }
  return context;
};

export const PaymentPlatformProvider = ({ children }) => {
  const [paymentPlatform, setPaymentPlatform] = useState('square');
  const [isDebugMode, setIsDebugMode] = useState(false);

  useEffect(() => {
    // Enable debug mode in non-production environments
    const isProduction = process.env.REACT_APP_ENV === 'production';
    setIsDebugMode(!isProduction);

    // Load saved payment platform preference from localStorage
    const savedPlatform = localStorage.getItem('debug_payment_platform');
    if (savedPlatform && !isProduction) {
      setPaymentPlatform(savedPlatform);
    }
  }, []);

  const switchPaymentPlatform = (platform) => {
    if (!isDebugMode) return; // Only allow switching in debug mode

    setPaymentPlatform(platform);
    localStorage.setItem('debug_payment_platform', platform);
  };

  const availablePlatforms = [
    { id: 'stripe', name: 'Stripe', description: 'Default Stripe integration' },
    { id: 'square', name: 'Square', description: 'Square payment processing' }
  ];

  const value = {
    paymentPlatform,
    switchPaymentPlatform,
    availablePlatforms,
    isDebugMode,
    currentPlatform: availablePlatforms.find(p => p.id === paymentPlatform)
  };

  return (
    <PaymentPlatformContext.Provider value={value}>
      {children}
    </PaymentPlatformContext.Provider>
  );
};

export default PaymentPlatformContext;